<template>
  <div>
    <pre>
      <code class="language-html">
    &lt;style>body {margin:0}&lt;/style>

    &lt;script
        type="text/javascript"
        src="https://tube.buzzoola.com/js/lib/banner.js">
    &lt;/script>

    &lt;div onclick="window.open('https://example.com/click'); buzzTrack('click');">

        &lt;img src="https://example/path/to/banner.png" width="300" height="250"/>

    &lt;/div>

    &lt;script type="text/javascript">buzzTrack('loaded');&lt;/script>
      </code>
    </pre>
    <div class="attention attention_pre-code attention_warn">
      <div class="attention__title">Внимание!</div>
      <p>При использовании шаблона выше, не забудьте поменять ссылку перехода <strong>https://example.com/click</strong>
        на актуальную.</p>
    </div>
  </div>
</template>

<script>
import hljs from '@/plugins/highlight.min';

export default {
  name: 'bannerExampleFixed',
  mounted() {
    hljs.highlightAll();
  },
};
</script>

<style scoped lang='stylus'>
@import '../../styles/darcula.min.css'
@import '../../styles/main.styl'
@import '../../styles/documentation_article_markup.styl'

</style>
